import { render, staticRenderFns } from "./StoreSettings.vue?vue&type=template&id=63ed2f81&scoped=true&"
import script from "./StoreSettings.vue?vue&type=script&lang=js&"
export * from "./StoreSettings.vue?vue&type=script&lang=js&"
import style0 from "./StoreSettings.vue?vue&type=style&index=0&id=63ed2f81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed2f81",
  null
  
)

export default component.exports